// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgMicrosoft = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <rect x={1} y={1} width={9} height={9} fill="#F25022" />
    <rect x={11} y={1} width={9} height={9} fill="#7FBA00" />
    <rect x={1} y={11} width={9} height={9} fill="#00A4EF" />
    <rect x={11} y={11} width={9} height={9} fill="#FFB900" />
  </svg>
);
export { SvgMicrosoft };
